module.exports = __webpack_public_path__ + "static/media/pHome_banner.7c1def82.jpg";